<form [formGroup]="buscarForm" novalidate (ngSubmit)="onSubmit()">
  <mat-card class="shipping-card">
    <mat-card-header>
      <mat-card-title>Buscar Faturas</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <input matInput placeholder="Competência" formControlName="competencia">
            <mat-error *ngIf="buscarForm.controls['competencia'].hasError('pattern')">
              ex: 2021-01
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field class="full-width">
            <input matInput placeholder="Cliente" formControlName="cliente">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <input matInput placeholder="Vencimento" formControlName="vencimento" [matDatepicker]="picker">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field class="full-width">
            <mat-select placeholder="Liberada" formControlName="liberada">
              <mat-option [value]="null">Todas</mat-option>
              <mat-option [value]="true">Sim</mat-option>
              <mat-option [value]="false">Não</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <input matInput type="number" placeholder="Número da fatura" formControlName="faturaId">
          </mat-form-field>
        </div>
        <div class="col"></div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" type="submit" [disabled]="!buscarForm.valid||carregando">Buscar</button>
    </mat-card-actions>
  </mat-card>
</form>
<mti-lista-faturas [faturas]="faturas" ></mti-lista-faturas>
